
import {Component, Prop, Vue} from "vue-property-decorator";
import {DataPropertyDefinition} from "@/store/modules/hds/Model";
import {DATA_PROPERTY_DEFINITION_DATA_TYPES} from "@/constants";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";

interface Popover {
  popperElm: Element;
}

@Component({
  components: {ReadonlyCheckbox},
})
export default class extends Vue {
  private dataTypes = DATA_PROPERTY_DEFINITION_DATA_TYPES;

  private popovers: Popover[] = [];

  @Prop({ required: true })
  value!: DataPropertyDefinition;

  beforeDestroy() {
    this.popovers.forEach(popover => popover.popperElm.remove());
  }

  handlePopupCreated(popover: Popover) {
    document.querySelector('#app')?.appendChild(popover.popperElm);
    this.popovers.push(popover);
  }
}
